

export const MOBILE_MONEY = "Mobile Money"
export const PAYPAL = "Paypal"
export const CREDIT_CARD = "Card"
export const CYBERSOURCE = "CyberSource"

export const codes = {
    "MTN": "*126#",
    "ORANGE": "#150*1#",
    "YOMEE": "#111#",
    "EXPRESS_UNION": "#222"
}

export const CardPaymentStatusCodes: Record<string, string> = {
   "0000": "Payment is successful.",
   "0001": "Request",
   "0002": "Customer cancelled the payment.",
   "0003": "Transaction was not authorized.",
   "0004": "Payment is pending",
   "0005": "Suspected fraud. Amount or currency customer paid not same as request.",
   "0006": "Merchant void the payment",
   "0007": "Merchant partial refund the payment.",
   "0008": "Merchant refund the payment.",
   "0009": "Redirect",
   "0010": "Need more info",
   "0011": "Expired",
   "0012": "Authorized",
}

// export const ProviderIdToProviderName: { [key: string]: string } = {
//     "u123a1b8490a4ea1335eed85a799a6fb": "MTN",
//     "b166771794fa2b1099212d5ff107e22a": "ORANGE",
//     "o911y2q8hg0a4ea19o52ed15h552a6hq": "YOMEE",
//     "n123m1b8490a4ea1335eed85b799a6fb": "EXPRESS_UNION"
// }